import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { CheckCardsListItem } from '@/modules/employer/components/Lockbox/lockbox.types';

import CheckMatchingMessage from './CheckMatchingMessage';
import CheckRadioButtonCard from './CheckRadioButtonCard';

interface Props {
  fields: CheckCardsListItem[];
  selectedCheckId?: string;
  onSelectCheck?: (checkId?: string) => void;
  emptyState?: React.ReactNode;
  showWarnings?: boolean;
  isEditMode?: boolean;
}

const ChecksList: React.FC<Props> = ({
  fields, selectedCheckId, onSelectCheck, emptyState, isEditMode, showWarnings,
}) => {
  const hasChecks = useMemo(() => fields?.length, [fields]);

  return (
    <>
      {hasChecks ? (
        fields?.map((field, index) => (
          <Box key={field?.id} {...index === 0 ? {} : { margin: { top: 'spacing8' } }}>
            <CheckRadioButtonCard
              testId="check-card"
              itemKey={field?.id}
              itemFields={field?.fields}
              isSelected={selectedCheckId === field?.id}
              onSelect={onSelectCheck}
              isEditMode={isEditMode}
            >
              {showWarnings && field?.warnings?.map((warning) => (
                <Box key={warning} margin={{ top: 'spacing8' }}>
                  <CheckMatchingMessage matchingType={warning} />
                </Box>
              ))}
            </CheckRadioButtonCard>
          </Box>
        ))
      ) : emptyState}
    </>
  );
};

export default ChecksList;
